import { useMemo } from "react";

function useNumberSpeech() {
  // 0-100 arası sayı haritasını bileşen her render olduğunda tekrar hesaplamamak için useMemo kullanıyoruz
  const numberMap100 = useMemo(() => {
    const ones = [
      "zero",
      "one",
      "two",
      "three",
      "four",
      "five",
      "six",
      "seven",
      "eight",
      "nine",
    ];
    const teens = [
      "ten",
      "eleven",
      "twelve",
      "thirteen",
      "fourteen",
      "fifteen",
      "sixteen",
      "seventeen",
      "eighteen",
      "nineteen",
    ];
    const tens = [
      "",
      "",
      "twenty",
      "thirty",
      "forty",
      "fifty",
      "sixty",
      "seventy",
      "eighty",
      "ninety",
    ];

    const map = {};

    for (let i = 0; i <= 100; i++) {
      if (i < 10) {
        map[i] = ones[i];
      } else if (i < 20) {
        map[i] = teens[i - 10];
      } else if (i < 100) {
        const tenDigit = Math.floor(i / 10);
        const oneDigit = i % 10;
        // Kelimeler arasında boşluk olmasına dikkat edildi: "twenty five"
        map[i] =
          oneDigit === 0
            ? tens[tenDigit]
            : `${tens[tenDigit]}${ones[oneDigit]}`;
      } else if (i === 100) {
        map[100] = "one hundred";
      }
    }

    return map;
  }, []);

  // Metni normalize eden ana fonksiyon
  const normalizeText = (text) => {
    if (!text) return "";

    let normalized = text
      .toString()
      .toLowerCase()
      .replace(/[.,/#!$%^&*;:{}=\-_`~()]/g, "") // Noktalama işaretlerini siler
      .trim();

    // 100'den 0'a doğru sayıları kelimelere çevirir (100, 99, 98 ... 0)
    Object.keys(numberMap100)
      .sort((a, b) => b - a)
      .forEach((num) => {
        const regex = new RegExp(`\\b${num}\\b`, "g");
        normalized = normalized.replace(regex, numberMap100[num]);
      });

    // Web Speech API'nin konuşurken karıştırdığı okunuşdaş (Homophone) kelimeler
    const homophones = {
      to: "two",
      too: "two",
      for: "four",
      fore: "four",
      won: "one",
      ate: "eight",
      be: "b",
      see: "c",
    };

    Object.keys(homophones).forEach((word) => {
      const regex = new RegExp(`\\b${word}\\b`, "g");
      normalized = normalized.replace(regex, homophones[word]);
    });

    return normalized;
  };

  return { normalizeText };
}

export default useNumberSpeech;
